import { createSelector } from 'reselect'
import { selectBuiltDashTabs, selectDashInput, selectDashTab } from './dash'

export const selectDashUi = createSelector(
  [selectBuiltDashTabs, selectDashInput, selectDashTab],
  (tabs, dashInput, selectedTab) => {
    return { tabs, dashInput, selectedTab }
  }
)
